const operatorOptions = [
  {
    "key": "CUSTOMER_OPERATED",
    "text": "Customer operated"
  },
  {
    "key": "CARD_ACCEPTOR_OPERATED",
    "text": "Card acceptor operated"
  },
];

export default operatorOptions;